var _defs, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #8e8e98;\n      }\n\n      .cls-2 {\n        fill: #ccc;\n      }\n\n      .cls-3 {\n        fill: #363c4f;\n      }\n    "))), /*#__PURE__*/React.createElement("g", {
    style: {
      visibility: "hidden"
    },
    id: "Layer_2",
    "data-name": "Layer 2"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 32,
    height: 32
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outlines"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.13,18.82h0c-1.52,0-2.94-.59-4.02-1.66s-1.67-2.5-1.67-4.02,.59-2.94,1.67-4.02,2.5-1.66,4.02-1.66,2.94,.59,4.02,1.66,1.67,2.5,1.67,4.02-.59,2.94-1.67,4.02h0c-1.07,1.07-2.5,1.66-4.02,1.66Zm0-10.37c-1.25,0-2.43,.49-3.31,1.37-.88,.88-1.37,2.06-1.37,3.31s.49,2.43,1.37,3.31,2.06,1.37,3.31,1.37h0c1.25,0,2.43-.49,3.31-1.37h0c.88-.88,1.37-2.06,1.37-3.31s-.49-2.43-1.37-3.31c-.88-.88-2.06-1.37-3.31-1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.43,13.13h-1c0-1.27-1.03-2.3-2.3-2.3v-1c1.82,0,3.3,1.48,3.3,3.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 17.18,
    y: 16.43,
    width: 1,
    height: 2.5,
    transform: "translate(-7.32 17.69) rotate(-45.01)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 17.6,
    y: 19.78,
    width: 6.62,
    height: 2.26,
    transform: "translate(20.91 -8.66) rotate(45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.45,24.76l-5.39-5.39,2.31-2.31,5.39,5.39-2.31,2.31Zm-3.97-5.39l3.97,3.97,.89-.89-3.98-3.97-.89,.89Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.195565fa49abc282e75b322086ded018.svg";
export { ForwardRef as ReactComponent };